import React, { useEffect, useState } from "react";
import styled from "styled-components";
import { Link } from "react-router-dom";
import Sidebar from "../Nav/Sidebar";
import Backdrop from "../Elements/Backdrop";
import BurgerIcon from "../../assets/svg/BurgerIcon";
import ProductDropdown from "./NavDropdown";

export default function TopNavbar() {
  const [y, setY] = useState(window.scrollY);
  const [sidebarOpen, toggleSidebar] = useState(false);

  useEffect(() => {
    window.addEventListener("scroll", () => setY(window.scrollY));
    return () => {
      window.removeEventListener("scroll", () => setY(window.scrollY));
    };
  }, [y]);

  return (
    <>
      <Sidebar sidebarOpen={sidebarOpen} toggleSidebar={toggleSidebar} />
      {sidebarOpen && <Backdrop toggleSidebar={toggleSidebar} />}
      <Wrapper
        className="whiteBg mt-0"
        style={
          y > 100 ? { height: "80px", marginTop: "0px" } : { height: "120px" }
        }
      >
        <NavInner className="flex justify-between sm:mx-10 md:mx-0 xl:mx-20">
          <Link className="" to="/">
            <img src="adoni/logo/adoniTech.png" className=" mt-3 h-14"></img>
          </Link>
          <BurderWrapper
            className="pointer"
            onClick={() => toggleSidebar(!sidebarOpen)}
          >
            <BurgerIcon />
          </BurderWrapper>
          <UlWrapper className="flexNullCenter">
            <li className="semiBold font15 pointer">
              <StyledLink
                style={{ padding: "10px 15px" }}
                to="/"
                spy={true}
                smooth={true}
                offset={-80}
              >
                Home
              </StyledLink>
            </li>
            <li className="semiBold font15 pointer">
              <StyledLink to="/About" style={{ padding: "10px 15px" }}>
                About
              </StyledLink>
            </li>
            <li className="semiBold font15 pointer">
              <StyledLink to="/Service" style={{ padding: "10px 15px" }}>
                Service
              </StyledLink>
            </li>
            <li className="semiBold pointer">
              <StyledLink to="/">
                <ProductDropdown />
              </StyledLink>
            </li>
            <li className="semiBold font15 pointer">
              <StyledLink to="/facility" style={{ padding: "10px 15px" }}>
                Facilities
              </StyledLink>
            </li>
            <li className="semiBold font15 pointer">
              <StyledLink
                to="/news-event-blog"
                style={{ padding: "10px 15px" }}
              >
                News & Blog
              </StyledLink>
            </li>
            <li className="semiBold font15 pointer">
              <StyledLink to="/Downloads" style={{ padding: "10px 15px" }}>
                Downloads
              </StyledLink>
            </li>
            <li className="semiBold font15 pointer">
              <StyledLink to="/contact-us" style={{ padding: "10px 15px" }}>
                Contact
              </StyledLink>
            </li>
            <li className="semiBold font15 pointer">
              <StyledLink to="/event" style={{ padding: "10px 15px" }}>
                Event
              </StyledLink>
            </li>
          </UlWrapper>
          <UlWrapperRight className="flexNullCenter">
            <li className="ml-4">
              <a
                href="https://calculation.adonitech.co.in/"
                className="rounded-md border border-blue-600 bg-blue-600 text-white hover:bg-black hover:text-white"
                style={{ padding: "10px 15px" }}
              >
                Go to Shock Absorber calculator
              </a>
            </li>
          </UlWrapperRight>
        </NavInner>
      </Wrapper>
    </>
  );
}

const Wrapper = styled.nav`
  width: 100%;
  position: fixed;
  top: 0;
  left: 0;
  z-index: 999;
  background-color: rgba(
    255,
    255,
    255,
    0.8
  ); /* Set semi-transparent background */
  backdrop-filter: blur(5px);
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
`;

const NavInner = styled.div`
  position: relative;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 20px;

  @media (max-width: 768px) {
    padding: 0 10px;
  }
`;

const BurderWrapper = styled.button`
  outline: none;
  border: 0px;
  background-color: transparent;
  height: 100%;
  padding: 0 15px;
  display: none;
  @media (max-width: 1169px) {
    display: block;
  }
`;

const UlWrapper = styled.ul`
  display: flex;
  align-items: center;
  list-style: none;
  padding: 0;
  margin: 0;

  @media (max-width: 1169px) {
    display: none;
  }
`;

const UlWrapperRight = styled.ul`
  display: flex;
  align-items: center;
  list-style: none;
  padding: 0;
  margin: 0;

  @media (max-width: 1169px) {
    display: none;
  }
`;

const StyledLink = styled(Link)`
  position: relative;
  text-decoration: none;
  color: inherit;

  &:hover::after,
  &.active::after {
    content: "";
    position: absolute;
    left: 25% !important;
    right: 25% !important;
    bottom: -2px;
    height: 2px;
    background-color: blue;
    border-radius: 2px;
  }
`;
